import i18n from "@/shared/i18n/i18n"
import { getCurrentLanguage } from "../Helpers"
import { getLanguage } from "../language/useLanguageSwitcher"
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

export function dateFormatter(value: number) {
    let locale = getLanguage()
    if (!locale)
        locale = getCurrentLanguage()
    return Intl.DateTimeFormat(locale, { dateStyle: "medium", timeZone: timezone }).format(new Date(value * 1000))
}

export function dateTimeShortFormatter(value: number) {
    let locale = getLanguage()
    if (!locale)
        locale = getCurrentLanguage()
    return Intl.DateTimeFormat(locale, { dateStyle: "short", timeStyle: "short", timeZone: timezone }).format(new Date(value * 1000))
}

export function dateTimeMediumFormatter(value: number) {
    let locale = getLanguage()
    if (!locale)
        locale = getCurrentLanguage()
    return Intl.DateTimeFormat(locale, { dateStyle: "short", timeStyle: "medium", timeZone: timezone }).format(new Date(value * 1000))
}

export function dateTimeFullFormatter(value: number) {
    let locale = getLanguage()
    if (!locale)
        locale = getCurrentLanguage()
    return Intl.DateTimeFormat(locale, { dateStyle: "long", timeStyle: "medium", timeZone: timezone }).format(new Date(value * 1000))
}

export function relativeDateTimeFormatter(value: number): string {
    const SECOND = 1000
    const MINUTE = 60 * SECOND
    const HOUR = 60 * MINUTE
    const DAY = 24 * HOUR
    let locale = getLanguage()
    if (!locale)
        locale = getCurrentLanguage()


    const now = Date.now()
    const date = new Date(value * 1000)
    const diff = now - date.getTime()

    if (diff < MINUTE) {
        return i18n.global.t("Interface.Time.LessThanMinuteAgo")
    }

    if (diff < HOUR) {
        const minutes = Math.round(diff / MINUTE)
        return i18n.global.t("Interface.Time.MinutesAgo", { count: minutes }, minutes)
    }

    if (diff < DAY) {
        const hours = Math.round(diff / HOUR)
        const tString = i18n.global.t("Interface.Time.HoursAgo", { count: hours }, hours)
        return tString
    }

    const yesterday = new Date(now - DAY)
    if (
        date.getDate() === yesterday.getDate() &&
            date.getMonth() === yesterday.getMonth() &&
            date.getFullYear() === yesterday.getFullYear()
    ) {
        const time = Intl.DateTimeFormat(locale, {
            hour: "2-digit",
            minute: "2-digit"
        }).format(date)
        return i18n.global.t("Interface.Time.YesterdayAt", { time })
    }

    return Intl.DateTimeFormat(locale, {
        dateStyle: "medium",
        timeZone: timezone
    }).format(date)
}

export function getLocalDateTimeWithTimezoneISOString(daysOffset: number = 0): string {
    const currentDate = new Date()
    const timezoneOffset = currentDate.getTimezoneOffset() * 60000

    const dateWithOffset = new Date(currentDate.getTime() + daysOffset * 24 * 60 * 60 * 1000)
    const localISOTime = new Date(dateWithOffset.getTime() - timezoneOffset).toISOString().slice(0, -1)

    return localISOTime
}
